export const stateFunctions = {
  getStateShortName,
  getStateNameFromShortName,
  mapStatesToList,
  getStateObject,
  findCountryNameCode,
};
// New Format
// {"regionID":6264,"name":"Alabama","shortName":"AL","availabilityCode":"Y"}
// Old Format
// { label: "Arizona", abbrev: "AZ", code: 3727, LSAvailable: "Y" },

function getStateNameFromShortName(shortName, stateList) {
  if (
    shortName === null ||
    shortName === undefined ||
    stateList === null ||
    stateList === undefined
  ) {
    return ""; // handle bad data so things don't explode?
  }
  let filteredStates = stateList?.filter((x) => {
    if (x?.shortName?.toUpperCase() === shortName?.toUpperCase()) {
      return x;
    }
  });
  if (filteredStates?.length > 0) return filteredStates[0]?.name;
  else return "";
}

function getStateShortName(stateName, stateList) {
  if (
    stateName === null ||
    stateName === undefined ||
    stateList === null ||
    stateList === undefined
  ) {
    return ""; // handle bad data so things don't explode?
  }
  let filteredStates = stateList.filter(
    (x) => x?.name?.toLowerCase() === stateName?.toLowerCase()
  );
  if (filteredStates?.length > 0)
    return filteredStates[0]?.shortName?.toUpperCase();
  else return "";
}

function mapStatesToList(input) {
  let results = input.map((item) => {
    return {
      label: item.name,
      shortName: item.shortName,
      availabilityCode: item.availabilityCode,
      regionID: item.regionID,
    };
  });
  return results;
}

function getStateObject(stateName, stateList) {
  if (
    stateName === null ||
    stateName === undefined ||
    stateList === null ||
    stateList === undefined
  ) {
    return ""; // handle bad data so things don't explode?
  }
  let filteredStates = stateList?.filter(
    (x) => x?.shortName?.toLowerCase() === stateName?.toLowerCase()
  );
  if (filteredStates?.length > 0)
    return filteredStates[0];
  else return "";
}


function findCountryNameCode(countryCode, countries) {
  let countryInfo;
  if (countryCode === "AUS") {
    countryInfo = countries?.filter((x) => x.code === "AUS");
  } else if(countryCode === "AU"){
    countryInfo = countries?.filter((x) => x.code === "AUS");
  } else if(countryCode === "NZ"){
    countryInfo = countries?.filter((x) => x.code === "NZL");
  } else if (countryCode === "EU") {
    countryInfo = countries?.filter((x) => x.code === "EU");
  } else if (countryCode === "USA") {
    countryInfo = countries?.filter((x) => x.code === "USA");
  } else if (countryCode === "CA") {
    countryInfo = countries?.filter((x) => x.code === "CAN");
  } else if (countryCode === "US") {
    countryInfo = countries?.filter((x) => x.code === "USA");
  } else{
    countryInfo = countries?.filter((x) => x.code === countryCode);
  }
  return countryInfo?.length > 0 ? countryInfo[0] : null;
}